import React, { useEffect, useState } from "react";

// Top-of-page scroll progress bar. Uses the existing palette-rail gradient
// but masks it from the right based on scroll progress to feel like a fill.
const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const p = total > 0 ? Math.min(100, (h.scrollTop / total) * 100) : 0;
      setProgress(p);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden
      className="fixed top-0 left-0 right-0 z-[61] h-[3px] pointer-events-none overflow-hidden"
    >
      {/* Always-on faint rainbow rail */}
      <div className="palette-rail h-full opacity-30" />
      {/* Filled progress overlay */}
      <div
        className="palette-rail h-full origin-left absolute inset-0"
        style={{
          transform: `scaleX(${progress / 100})`,
          transition: "transform 60ms linear"
        }}
      />
    </div>
  );
};

export default ScrollProgress;
